import { useRegisterAgentContext } from '@backrs_ui/grow-ui/src/agentContext/useRegisterAgentContext';
import {
  MILESTONE_MONTHS,
  calendarOfMilestonesStrings,
  type MilestoneYearLevel,
} from '@backrs_ui/grow-ui/src/pages/SuccessSystem/calendarOfMilestones.content';

export const useAgentContext = (yearLevel: MilestoneYearLevel) => {
  useRegisterAgentContext({
    kind: 'section',
    title: `${calendarOfMilestonesStrings.tabLabel}: ${yearLevel.label}`,
    description: 'Month-by-month critical priorities for the selected year level.',
    detail: MILESTONE_MONTHS.map((month) => {
      const milestone = yearLevel.milestones[month];

      return `${month} - ${milestone.title}: ${milestone.content} Focus: ${milestone.focus.join(', ')}`;
    }).join('\n'),
  });
};
